<div class="container">
	<div class="overlay-bg"></div>
	<div class="mid-content">
		@if (form) {
			<div
				class="p-relative form-container"
				style="
					margin-right: 1px;
					border-top-left-radius: 25px;
					border-bottom-left-radius: 25px;
					background-color: white;
				">
				<div @fadeAndSlideUp>
					<form novalidate [formGroup]="form" (submit)="sendResetLink(form.value)">
						<p-card class="nice-border">
							<div class="ui-g login-block p-1">
								<div class="ui-g-12 ui-lg-12 p-0">
									<div class="text-center">
										<img src="./assets/img/smartyCubes-logo.png" alt="SmartyCube" />
									</div>
									<label style="text-align: center">
										<b style="font-weight: 500">{{ 'login.reset-password-title' | translate }}</b>
									</label>
								</div>
								<div class="ui-lg-12 ui-md-12 ui-g-12">
									<label>
										<b>{{ 'login.password' | translate }}</b>
									</label>
									<input
										placeholder="{{ 'login.password' | translate }}"
										type="password"
										class="w-100"
										pPassword
										[feedback]="false"
										name="password"
										formControlName="password" />
									<span class="information">
										<i class="fas fa-question-circle"></i>
										{{ 'login.valid-password-title' | translate }}
									</span>
									<sis-validation-summary
										[form]="form"
										name="password"
										[visible]="invalidForm"></sis-validation-summary>
								</div>
								<div class="ui-lg-12 ui-md-12 ui-g-12 pb-2">
									<label>
										<b>{{ 'login.confirm-password' | translate }}</b>
									</label>
									<input
										placeholder="{{ 'login.confirm-password' | translate }}"
										type="password"
										class="w-100"
										pPassword
										[feedback]="false"
										name="confirmPassword"
										formControlName="confirmPassword" />
									<sis-validation-summary
										[form]="form"
										name="confirmPassword"
										[visible]="invalidForm"></sis-validation-summary>
								</div>
								<ng-template #footer>
									<div class="ui-lg-12 login-border text-right">
										<button
											pButton
											type="submit"
											label="{{ 'login.create-password' | translate }}"
											icon="fas fa-unlock-alt"
											[disabled]="form.invalid"
											class="action-btn btn-color ui-green-button"></button>
									</div>
								</ng-template>
							</div>
						</p-card>
					</form>
				</div>
			</div>
		}
		<div class="p-relative img-container">
			<div style="height: 100%" @fadeAndSlideUp>
				<div class="card-right" style="margin-left: -1px">
					<img src="./assets/img/smartyCube-login-image.png" />
				</div>
			</div>
		</div>
	</div>
</div>
